import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input-group" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "report-search",
  class: "sr-only"
}, "Search", -1)
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-btn ml-2" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-outline-primary"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" })
  ])
], -1)

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

// Define the placeholder prop.

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchByString',
  props: {
    placeholder: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const router = useRouter();

// Computed setter and getter for the search value that uses the store
const search = computed({
  get: () => store.state.reports.search,
  set: (val: string | undefined) => store.commit('reports/setSearch', val),
});

// Actions using the store.dispatch
const resetCurrentPage = async () => {
  await store.dispatch('reports/resetCurrentPage');
};

// Methods converted to arrow functions
const onSubmit = async () => {
  await router.push({ path: 'reports', query: { search: search.value }});
  await resetCurrentPage();
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "form",
    onSubmit: _withModifiers(onSubmit, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("input", {
        id: "report-search",
        type: "search",
        class: "form-control",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
        placeholder: _ctx.placeholder,
        autocomplete: "off"
      }, null, 8, _hoisted_3), [
        [_vModelText, search.value]
      ]),
      _hoisted_4
    ])
  ], 32))
}
}

})